import { render, staticRenderFns } from "./AmazonProductDetail.vue?vue&type=template&id=7827653f&scoped=true&"
import script from "./AmazonProductDetail.vue?vue&type=script&lang=js&"
export * from "./AmazonProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827653f",
  null
  
)

export default component.exports